import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    class: _vm.is100h ? 'H100' : 'H60',
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('h6', {
    staticClass: "titleBox"
  }, [_vm._v(i18n.tc("400"))]), _c('x-button', {
    staticClass: "addBtn",
    nativeOn: {
      "click": function ($event) {
        _vm.isShowAddProduct = true;
      }
    }
  }, [_vm._v(i18n.tc("229"))]), _c('div', {
    staticClass: "close_btn_box",
    on: {
      "click": function ($event) {
        _vm.currValue = false;
      }
    }
  }, [_c('img', {
    staticClass: "close_btn",
    attrs: {
      "src": require("@/assets/icon/close_btn.png"),
      "alt": ""
    }
  })]), _c('view-box', {
    ref: "viewBox",
    staticClass: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_vm._l(_vm.customerPro, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "produce-info"
    }, [_c('img', {
      attrs: {
        "src": _vm.replaceMultiImg(item.img_url || '/spa_static_mobile/icon/spare120_120@3x.png'),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "product_name"
    }, [_vm._v(_vm._s(item.productName))]), _c('div', {
      staticClass: "product_sn"
    }, [_vm._v(i18n.tc("227") + _vm._s(item.productionSn))])])]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.customerPro.length,
      expression: "!customerPro.length"
    }],
    staticClass: "no-result-body"
  }, [_c('div', {
    staticClass: "no-result"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/none.png"
    }
  })])])], 2), _c('AddProduct', {
    on: {
      "on-success": _vm.getCustomerPro
    },
    model: {
      value: _vm.isShowAddProduct,
      callback: function ($$v) {
        _vm.isShowAddProduct = $$v;
      },
      expression: "isShowAddProduct"
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };